import React from "react";
import BookingReservationSegment from "./BookingReservationSegment";
import numeral from "numeral";
import DateHelper from "../DateHelper/DateHelper";
import { format } from "date-fns";

export default class BookingFlowTotal extends React.Component {
  constructor(props) {
    super(props);

    this.onChangeStep = this.onChangeStep.bind(this);
    this.singularize = this.singularize.bind(this);
    this.subtotalAmount = this.subtotalAmount.bind(this);
    this.totalAmount = this.totalAmount.bind(this);
    this.vouchersAmount = this.vouchersAmount.bind(this);
  }

  render() {
    
    var self = this;
    if (this.props.portal && this.props.reservation_segment) {
      var add_ons = undefined;
      if (self.props.add_ons) {
        add_ons = self.props.add_ons[this.props.reservation_segment.id];
      }
      var reservation_segments = [
        <BookingReservationSegment
          portal={self.props.portal ? self.props.portal : null}
          {...self.props}
          reservation_segment={self.props.reservation_segment}
          add_ons={add_ons}
          key={self.props.reservation_segment.id}
        />,
      ];
    } else if (this.props.reservation_segments) {
      var reservation_segments = this.props.reservation_segments.map(function (
        reservation_segment
      ) {
        var add_ons = undefined;
        if (self.props.add_ons) {
          add_ons = self.props.add_ons[reservation_segment.id];
        }
        return (
          <BookingReservationSegment
            portal={self.props.portal ? self.props.portal : null}
            {...self.props}
            reservation_segment={reservation_segment}
            add_ons={add_ons}
            key={reservation_segment.id}
          />
        );
      });
    }

    if (this.props.vouchers && this.props.vouchers.length > 0) {
      var vouchers = this.props.vouchers.map((voucher, index) => {
        return (
          <div
            key={index}
            className="ReservationTotal"
            style={{ marginBottom: "0.5rem" }}
          >
            <table className="table pricing-table voucher">
              <tbody>
                <tr>
                  <td className="text-left amounts">
                    <strong>
                      {this.singularize(
                        this.props.vouchers_menu_label || I18n.t("voucher")
                      )}
                    </strong>
                    {""}
                    <a
                      href="#"
                      className="remove-voucher"
                      onClick={this.props.onRemoveVoucher.bind(
                        this,
                        index
                      )}
                      style={{ textDecoration: "none", marginLeft: "5px" }}
                    >
                      <span className="ss-trash"></span>
                    </a>
                  </td>
                  <td className="text-right amount">
                    {self.props.currency.symbol}
                    {numeral(
                      (voucher.amount * self.props.currency.exchange_rate) / 100
                    ).format(self.props.number_format)}
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" className="text-left">
                    <div className="reservation-segment-date-range">
                      ({I18n.t("sending_to")}{" "}
                      <span className="recipient-email">
                        {voucher.recipient_email}
                      </span>{" "}
                      {I18n.t("on")}{" "}
                      <span className="delivery-date">
                        {DateHelper.printDateToScreen(voucher.delivery_date, this.props.date_format)}
                      </span>
                      )
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      });
    }
    
    
    return (
      <div
        className="card cart"
        style={{ marginBottom: "15px", padding: "0rem" }}
      >
        {reservation_segments}

        <div className="ReservationTotal" style={{ padding: "0.5rem" }}>
          {!this.props.portal &&
          !this.props.reservation_builder && reservation_segments &&
          reservation_segments.length > 0 ? (
            <div>
              <a href="#" onClick={this.onChangeStep}>
                {I18n.t("add_another_room")}
              </a>
            </div>
          ) : null}

          {reservation_segments &&
          reservation_segments.length > 0 &&
          vouchers &&
          vouchers.length > 0 ? (
            <hr style={{ marginBottom: "15px" }} />
          ) : null}

          {vouchers}

          {(reservation_segments && reservation_segments.length) || (vouchers && vouchers.length) ? (
            <hr style={{ marginTop: "20px", marginBottom: "15px" }} />
          ) : null}

          <table className="table pricing-table" style={{ margin: 0 }}>
            {this.props.portal && this.props.reservation_segment ? (
              <tbody>
                <tr>
                  <td className="text-left amounts">
                    <strong>{I18n.t("subtotal")}</strong>
                  </td>
                  <td className="text-right amounts">
                    {this.props.currency.symbol}
                    {numeral(
                      (this.props.reservation_segment.subtotal_amount *
                        this.props.currency.exchange_rate) /
                        100
                    ).format(self.props.number_format)}
                  </td>
                </tr>
                <tr>
                  <td className="text-left amounts">
                    <strong>{I18n.t("taxes_and_fees")}</strong>
                  </td>
                  <td className="text-right amounts">
                    {this.props.currency.symbol}
                    {numeral(
                      (this.props.reservation_segment.taxes_and_fees_amount *
                        this.props.currency.exchange_rate) /
                        100
                    ).format(self.props.number_format)}
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td className="text-left amounts">
                    <strong>{I18n.t("subtotal")}</strong>
                  </td>
                  <td className="text-right amounts">
                    {this.props.currency.symbol}
                    {numeral(this.subtotalAmount()).format(
                      self.props.number_format
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="text-left amounts">
                    <strong>{I18n.t("taxes_and_fees")}</strong>
                  </td>
                  <td className="text-right amounts">
                    {this.props.currency.symbol}
                    {numeral(
                      ((this.props.reservation ? this.props.reservation.taxes_and_fees_amount : this.props.order ? this.props.order.taxes_and_fees_amount : 0) *
                        this.props.currency.exchange_rate) /
                        100
                    ).format(self.props.number_format)}
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
        <div
          className="ReservationTotal"
          style={{
            padding: "0.5rem 0",
            margin: "0 0.5rem",
          }}
        >
          <table className="table pricing-table">
            <tbody>
              <tr>
                <td className="text-left amounts">
                  <strong>{I18n.t("total")}</strong>
                </td>
                {this.props.portal && this.props.reservation_segment ? (
                  <td className="text-right amounts">
                    {this.props.currency.symbol}
                    {numeral(
                      (this.props.reservation_segment.total_amount *
                        this.props.currency.exchange_rate) /
                        100
                    ).format(self.props.number_format)}
                  </td>
                ) : (
                  <td className="text-right amounts">
                    {this.props.currency.symbol}
                    {numeral(this.totalAmount()).format(
                      self.props.number_format
                    )}
                  </td>
                )}
              </tr>
              {this.props.voucher ? (
                <tr>
                  <td className="text-left amounts">
                    <strong>{I18n.t("voucher")}</strong>
                  </td>
                  <td className="text-right amounts">
                    -{this.props.currency.symbol}
                    {numeral(
                      (this.props.voucher.balance *
                        this.props.currency.exchange_rate) /
                        100
                    ).format(self.props.number_format)}
                  </td>
                </tr>
              ) : null}
              {this.props.show_due_today === false ? null : (
                <tr>
                  <td className="text-left amounts">
                    <strong>{I18n.t("due_today")}</strong>
                  </td>
                  <td className="text-right amounts">
                    {this.props.currency.symbol}
                    {numeral(
                      this.props.bookingPaymentAmount
                        ? (this.calculateDueToday(
                            this.props.bookingPaymentAmount
                          ) *
                            this.props.currency.exchange_rate) /
                            100
                        : (this.calculateDueToday(
                            this.props.reservation ? this.props.reservation.amount_due_at_booking : 0
                          ) *
                            this.props.currency.exchange_rate) /
                            100
                    ).format(self.props.number_format)}
                  </td>
                </tr>
              )}
              {this.props.voucher ? (
                <tr>
                  <td className="text-left amounts voucher-balance-after-payment">
                    <strong>{I18n.t("voucher_balance")}</strong>
                  </td>
                  <td className="text-right amounts voucher-balance-after-payment">
                    {this.props.currency.symbol}
                    {numeral(
                      (this.calculateVoucherBalance() *
                        this.props.currency.exchange_rate) /
                        100
                    ).format(self.props.number_format)}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  vouchersAmount() {
    var vouchersAmount = (this.props.vouchers || []).reduce(function (
      sum,
      voucher
    ) {
      return sum + voucher.amount;
    },
    0);
    return vouchersAmount;
  }

  subtotalAmount() {
    return (
      (((this.props.reservation?.subtotal_amount || 0) + this.vouchersAmount()) *
        this.props.currency.exchange_rate) /
      100
    );
  }

  totalAmount() {
    return (
      (((this.props.reservation?.total_amount || 0) + this.vouchersAmount()) *
        this.props.currency.exchange_rate) /
      100
    );
  }

  calculateDueToday = (bookingAmount) => {
    
    
    bookingAmount = bookingAmount || 0;
    var vouchers_amount = this.vouchersAmount();
    
    if (bookingAmount || vouchers_amount) {
      if (this.props.voucher) {
        const dueToday =
          bookingAmount + vouchers_amount - this.props.voucher.balance;
        if (dueToday >= 0) {
          return dueToday;
        } else {
          return 0;
        }
      } else {
        return bookingAmount + vouchers_amount;
      }
    }
  };

  calculateVoucherBalance = () => {
    const dueToday = this.props.bookingPaymentAmount
      ? this.props.bookingPaymentAmount
      : this.props.reservation.amount_due_at_booking;
    const balanceAfterPayment = this.props.voucher.balance - dueToday;

    if (balanceAfterPayment > 0) {
      return balanceAfterPayment;
    } else {
      return 0;
    }
  };

  getProduct(id) {
    for (var i = 0, ilen = this.props.products.length; i < ilen; i++) {
      var product = this.props.products[i];
      if (product && product.id === id) {
        return product;
      }
    }
  }

  singularize(word) {
    if (!word) {
      return word;
    }

    const endings = {
      ves: "fe",
      ies: "y",
      i: "us",
      zes: "ze",
      ses: "s",
      es: "e",
      s: "",
    };

    return word.replace(
      new RegExp(`(${Object.keys(endings).join("|")})$`),
      (r) => endings[r]
    );
  }

  onChangeStep(e) {
    e.stopPropagation();
    e.preventDefault();
    this.props.onChangeStep("accommodations");
  }
}
